import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../../config/api";
import { PleasewaitPopup } from "../../../components/PleasewaitPopup";
import CustomFormatDatePicker from "../../../components/CustomFormatDatePicker";
import useAuth from "../../../hooks/useAuth";

export const AddGratuityRule = () => {
    const navigate = useNavigate();
    const { auth }: any = useAuth();

    const [vehicleTypeId, setVehicleTypeId] =
        useState<string>("");

    const [calculationType, setCalculationType] =
        useState<string>("percentage");

    const [calculationBase, setCalculationBase] =
        useState<string>("base_cost");

    const [percentage, setPercentage] =
        useState<string>("0");

    const [amount, setAmount] =
        useState<string>("0");

    const [isOptional, setIsOptional] =
        useState<string>("Yes");

    const [isTaxable, setIsTaxable] =
        useState<string>("No");

    const [priority, setPriority] =
        useState<string>("0");

    const [validFrom, setValidFrom] =
        useState<string>("");

    const [validTo, setValidTo] =
        useState<string>("");

    const [enabled, setEnabled] =
        useState<string>("No");

    const [description, setDescription] =
        useState<string>("");

    const [pleaseWaitPopup, setPleaseWaitPopup] =
        useState<boolean>(false);

    const [vehicleTypeOptions, setVehicleTypeOptions] =
        useState<any[]>([]);


    useEffect(() => {
        axios
            .get(`${baseURL}vehicle-types/`)
            .then((response) => {
                const vehicleTypes =
                    response.data.data || [];

                setVehicleTypeOptions(
                    vehicleTypes.map((item: any) => ({
                        value: item.id,
                        label: item.name,
                    }))
                );

                setVehicleTypeId(
                    String(
                        vehicleTypes[0]?.id ?? ""
                    )
                );
            })
            .catch((error) => {
                setVehicleTypeOptions([]);
                setVehicleTypeId("");
                console.error(error);
            });
    }, []);


    const handleSubmit = async (
        e: React.FormEvent<HTMLFormElement>
    ) => {
        e.preventDefault();

        setPleaseWaitPopup(true);

        const payload = {
            vehicle_type_id: vehicleTypeId
                ? Number(vehicleTypeId)
                : null,

            calculation_type:
                calculationType,

            calculation_base:
                calculationBase,

            percentage:
                calculationType === "percentage"
                    ? Number(percentage)
                    : null,

            amount:
                calculationType === "fixed"
                    ? Number(amount)
                    : null,

            is_optional:
                isOptional === "Yes",

            is_taxable:
                isTaxable === "Yes",

            priority:
                Number(priority),

            valid_from: validFrom
                ? new Date(
                    validFrom
                ).toISOString()
                : null,

            valid_to: validTo
                ? new Date(
                    validTo
                ).toISOString()
                : null,

            is_active:
                enabled === "Yes",

            description:
                description.trim(),

            created_by:
                auth?.givenname,
        };

        await axios
            .post(
                `${baseURL}gratuity-rules/`,
                payload,
                {
                    headers: {
                        "Content-Type":
                            "application/json",
                    },
                    withCredentials: false,
                }
            )
            .then(() => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);

                console.error(
                    "Error creating gratuity rule:",
                    error
                );
            });
    };


    return (
        <>
            <div className="px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto">

                <div className="w-full bg-white p-4 rounded-md">

                    <h2 className="text-lg font-semibold">
                        Add Gratuity Rule
                    </h2>

                    <div className="mt-2 p-2">

                        <form onSubmit={handleSubmit}>

                            <div className="w-full">


                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Vehicle Type{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <select
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={vehicleTypeId}
                                            onChange={(e) =>
                                                setVehicleTypeId(
                                                    e.target.value
                                                )
                                            }
                                            required
                                        >
                                            {vehicleTypeOptions?.map(
                                                (vehicleType: any) => (
                                                    <option
                                                        key={
                                                            vehicleType.value
                                                        }
                                                        value={String(
                                                            vehicleType.value
                                                        )}
                                                    >
                                                        {
                                                            vehicleType.label
                                                        }
                                                    </option>
                                                )
                                            )}
                                        </select>
                                    </div>


                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Calculation Type{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <select
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={calculationType}
                                            onChange={(e) =>
                                                setCalculationType(
                                                    e.target.value
                                                )
                                            }
                                            required
                                        >
                                            <option value="percentage">
                                                Percentage
                                            </option>

                                            <option value="fixed">
                                                Fixed
                                            </option>
                                        </select>
                                    </div>

                                </div>



                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Calculation Base{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <select
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={calculationBase}
                                            onChange={(e) =>
                                                setCalculationBase(
                                                    e.target.value
                                                )
                                            }
                                            required
                                        >
                                            <option value="base_cost">
                                                Base Cost
                                            </option>

                                            <option value="driver_cost">
                                                Driver Cost
                                            </option>

                                            <option value="subtotal">
                                                Subtotal
                                            </option>

                                            <option value="service_amount">
                                                Service Amount
                                            </option>
                                        </select>
                                    </div>


                                    {calculationType ===
                                        "percentage" && (
                                            <div>
                                                <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                                    Percentage
                                                    <span className="text-red-500">
                                                        {" "}*
                                                    </span>
                                                </label>

                                                <input
                                                    type="number"
                                                    min="0"
                                                    max="100"
                                                    step="any"
                                                    className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                                    value={percentage}
                                                    onChange={(e) =>
                                                        setPercentage(
                                                            e.target.value
                                                        )
                                                    }
                                                    required
                                                />
                                            </div>
                                        )}


                                    {calculationType ===
                                        "fixed" && (
                                            <div>
                                                <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                                    Amount
                                                    <span className="text-red-500">
                                                        {" "}*
                                                    </span>
                                                </label>

                                                <input
                                                    type="number"
                                                    min="0"
                                                    step="any"
                                                    className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                                    value={amount}
                                                    onChange={(e) =>
                                                        setAmount(
                                                            e.target.value
                                                        )
                                                    }
                                                    required
                                                />
                                            </div>
                                        )}

                                </div>


                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Optional
                                        </label>

                                        <select
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={isOptional}
                                            onChange={(e) =>
                                                setIsOptional(
                                                    e.target.value
                                                )
                                            }
                                        >
                                            <option value="Yes">
                                                Yes
                                            </option>

                                            <option value="No">
                                                No
                                            </option>
                                        </select>
                                    </div>


                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Taxable
                                        </label>

                                        <select
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={isTaxable}
                                            onChange={(e) =>
                                                setIsTaxable(
                                                    e.target.value
                                                )
                                            }
                                        >
                                            <option value="No">
                                                No
                                            </option>

                                            <option value="Yes">
                                                Yes
                                            </option>
                                        </select>
                                    </div>

                                </div>


                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Priority
                                        </label>

                                        <input
                                            type="number"
                                            min="0"
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={priority}
                                            onChange={(e) =>
                                                setPriority(
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </div>

                                </div>


                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Valid From
                                        </label>

                                        <CustomFormatDatePicker
                                            value={validFrom}
                                            onChange={(value) => {
                                                setValidFrom(value);
                                            }}
                                            required={true}
                                        />
                                    </div>


                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Valid To
                                        </label>

                                        <CustomFormatDatePicker
                                            minDate={
                                                validFrom ||
                                                undefined
                                            }
                                            value={validTo}
                                            onChange={(value) => {
                                                setValidTo(value);
                                            }}
                                            required={true}
                                        />
                                    </div>

                                </div>


                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Active
                                        </label>

                                        <select
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={enabled}
                                            onChange={(e) =>
                                                setEnabled(
                                                    e.target.value
                                                )
                                            }
                                        >
                                            <option value="No">
                                                No
                                            </option>

                                            <option value="Yes">
                                                Yes
                                            </option>
                                        </select>
                                    </div>

                                </div>


                                <div className="mb-4">

                                    <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                        Description
                                    </label>

                                    <textarea
                                        rows={4}
                                        value={description}
                                        onChange={(e) =>
                                            setDescription(
                                                e.target.value
                                            )
                                        }
                                        placeholder="Enter gratuity rule description"
                                        className="w-full p-4 border border-gray-300 rounded-md bg-white resize-none outline-none focus:border-primary"
                                    />

                                </div>


                                <div className="flex flex-col sm:flex-row gap-4 mt-6">

                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>

                                    <button
                                        type="button"
                                        onClick={() =>
                                            navigate(-1)
                                        }
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-white text-primary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>

                                </div>

                            </div>

                        </form>

                    </div>
                </div>
            </div>

            <PleasewaitPopup
                showPopup={pleaseWaitPopup}
            />
        </>
    );
};